import React from 'react';
import { Loadable } from 'shared/hocs/loadable';
import { Loader } from 'shared/ui/loader';


export const SurveyConstructorLoadable = Loadable({
    loader: (): any => import('./SurveyConstructor').then((res) => res.SurveyConstructor),
    loading: <Loader/>,
});
